import { RowData } from '@components/process-import-csv/src/process-import-csv.type';

export const IMPORT_CSV_QUERY = 'import-csv';
export const GET_IMPORT_CSV_STATUS_QUERY = 'get-import-csv-status';

export interface ImportFormData {
  eventId: string;
  offerId: string;
  channelId: string;
  rows: RowData[];
  addOns?: { id: string; quantity: number }[];
}

export interface ImportArguments {
  importData: ImportFormData;
}

export type ImportResponse = Promise<{ importId: string }>;

export interface ImportCsvStatusFailedResponse {
  quantity: number;
  rows: number[];
}
export interface ImportCsvStatusResponse {
  importId: string;
  pending: number;
  completed: number;
  failed: ImportCsvStatusFailedResponse;
}
